import React, { useEffect, useState, useRef } from "react";

const Popup = (props) => {
  const [detail, setDetail] = useState();
  const modalRef = useRef(null);

  useEffect(() => {
    if (props.data) {
      setDetail(props.data[0]);
    }
  }, [props.data]);

  useEffect(() => {
    if (detail) {
    }
  }, [detail]);

  useEffect(() => {
    function handleClickOutside(event) {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        props.onClick();
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [props.onClick]);

  if (!detail) return null;

  return (
    <div
      className={`modal commom-modal blog-modal fade ${
        props.showBoolean ? "show showModal" : "hide hideModal"
      }`}
      id="portfolioModal"
      tabIndex="-1"
      aria-hidden="true"
    >
      <div className="modal-dialog">
        <div className="modal-content">
          <button
            className="modal-close"
            data-bs-dismiss="modal"
            aria-label="Close"
            ref={modalRef}
            onClick={props.onClick}
          >
            <div className="bi bi-x"></div>
          </button>
          <div className="modal-body">
            <div className="text-center">
              <h2 className="blog-title text-black">{detail.heading}</h2>
            </div>
            <div className="d-flex justify-content-between modal-info gap-3 flex-wrap">
              <div className="modal-info-box">
                <h5>Category</h5>
                <p>{detail.category}</p>
              </div>
              <div className="modal-info-box">
                <h5>Client</h5>
                <p>{detail.client}</p>
              </div>
              <div className="modal-info-box">
                <h5>Date</h5>
                <p>{detail.date}</p>
              </div>
              <div className="modal-info-box">
                <h5>Preview</h5>
                <p>
                  <a target="_blank" href={detail.previewLink}>
                    {detail.previewLink}
                  </a>
                </p>
              </div>
            </div>
            <div className="blog-thumb row">
              <div className="col-12">
                <img
                  src={`${process.env.REACT_APP_ASSET_KEY}${detail.displayImg}`}
                  alt="portfolio"
                />
              </div>
            </div>
            <div className="blog-disc">
              <h4 className="text-xl">{detail.subHeading}</h4>
              <p>{detail.description}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Popup;
